import { Action } from './actions';
import { openApplications } from './applicationReducer';
import { removeObjPropertyImmutably } from '../utils/removePropertyImmutably';
import { State, IOpenApplications } from './state';
import { CommunicationType } from '../models/communication.ts';

export function rootReducer(state: State, action: Action) {
  switch (action.scope.parentType) {
    case 'openApplications':
      return {
        ...reducer(state, action),
        openApplications: openApplications(state.openApplications, action),
      };
    default:
      return reducer(state, action);
  }
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'Open application':
      return {
        ...state,
        openApplications: {
          ...state.openApplications,
          [action.scope.id]: {
            applicationID: action.scope.id,
            humanReadableID: action.payload.humanReadableID,
            marketCountry: action.payload.marketCountry,
            communicationTab: CommunicationType.CallsAndComments,
          },
        },
      };
    case 'Close application':
      return {
        ...state,
        openApplications: removeObjPropertyImmutably<IOpenApplications>(
          state.openApplications,
          action.scope.id,
        ),
      };
    case 'Set error':
      return { ...state, error: action.payload };
    case 'Set market country':
      return { ...state, marketCountry: action.payload };
    default:
      return state;
  }
}
